module.exports = __webpack_public_path__ + "img/domicilio.02f894f3.jpg";